import React, { useMemo } from "react";
import { useDebouncedState } from "../../../../../utilities/hooks/useDebouncedState";
import { useSmsSnippetsQuery } from "../../../../../api/smsSnippets/useSmsSnippetsQuery";
import { PatternAutocomplete } from "../../../../../widgets/PatternAutocomplete/PatternAutocomplete";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../utilities/api";

export const MessageTextarea = ({ value, onChange, maxLength }) => {
  const [_, debouncedText, setText] = useDebouncedState("");
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets",
  });

  const { data } = useSmsSnippetsQuery(
    {
      name: debouncedText,
    },
    {
      onError: (res) => {
        const message = extractApiError(res);
        uiNotification.error(t([`error.${message}`, "error.getAll"]));
      },
    },
  );

  const substitutes = useMemo(
    () =>
      data?.map((x) => ({
        label: x.name,
        value: x.phrase,
        description: x.title,
      })) || [],
    [data],
  );

  return (
    <PatternAutocomplete
      patterns={[
        {
          match: ".",
          substitutes,
        },
      ]}
      value={value}
      placeholder="Type a message..."
      maxLength={maxLength}
      maxRows={10}
      onTokenFound={({ matchedText }) => setText(matchedText)}
      onChange={onChange}
      className={styles.textarea}
    />
  );
};
